const scrollToErrors = formik => {
  const errorKeys = Object.keys(formik.errors);
  const errorElement = document
  .getElementsByName(errorKeys[0])[0]

  if (errorKeys.length > 0 && errorElement ) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      errorElement.focus({ preventScroll: true });
  }
};

export default scrollToErrors;
